
import {defineComponent} from 'vue';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

export default defineComponent({
	components: {FontAwesomeIcon},
	emits: ['close'],
	setup(props, context) {
		const close = () => context.emit('close');
		return {close};
	},
});
